import _objectSpread from "/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import FormBox from '../../components/FormBox';
import { imageLoad, kfltApi } from '../../api/myApi.js';
import CheckBook from '../../components/CheckBook';
import dayjs from 'dayjs';
import { Toast } from 'vant';
export default {
  name: 'Home',
  components: {
    FormBox: FormBox,
    CheckBook: CheckBook
  },
  data: function data() {
    return {
      minDate: new Date(),
      // 设置为当前时间
      checked: false,
      data: {
        appointmentTime: ''
      },
      isIpt: true,
      hospitalList: [],
      showPicker: false,
      scblImages: [],
      rules: {
        age: [{
          required: true,
          message: '请输入年龄',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择地区',
          trigger: 'change'
        }],
        hospital: [{
          required: true,
          message: '请选择医院',
          trigger: 'change'
        }],
        appointmentTime: [{
          required: true,
          message: '请选择预约时间',
          trigger: 'blur'
        }],
        uploader: [{
          required: true,
          message: '请选择病例',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    onConfirm: function onConfirm(time) {
      var _this = this;
      console.log(time);
      var now = dayjs(time);
      this.data.appointmentTime = now.format('YYYY-MM-DD HH:mm:ss');
      this.$nextTick(function () {
        _this.$refs.form.validateField('appointmentTime'); // 手动触发验证
        _this.showPicker = false;
      });
    },
    inspectBtn: function inspectBtn(topData, isD) {
      this.isIpt = isD;
      this.data = _objectSpread(_objectSpread({}, this.data), topData);
    },
    afterReadAvatar: function afterReadAvatar(file) {
      var _this2 = this;
      var formData = new FormData();
      formData.append('file', file.file);
      imageLoad(formData).then(function (res) {
        _this2.scblImages.push({
          imgUrl: res.url,
          imgId: file.file.lastModified
        });
      });
    },
    scblBeforeDelete: function scblBeforeDelete(index) {
      this.scblImages = this.scblImages.filter(function (item) {
        return item.imgId !== index.file.lastModified;
      });
    },
    onSubmit: function onSubmit(formName) {
      var params = _objectSpread(_objectSpread({}, this.data), {}, {
        medicalRecordFile: this.scblImages.map(function (item) {
          return item.imgUrl;
        }).join(','),
        serviceType: '4'
      });
      console.log(params, '111');
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          kfltApi(params).then(function (res) {
            Toast.success(res.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};